import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CircleFilledIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CircleFilledIconPath";
import { ComponentNotificationTitleSeriesUpdate } from "@fixa/notifications";
import { getTitleAssignerString } from "../utils/task-notification-title";
import styles from "../task-notification.module.css";
import { useTranslation } from "@coworker/locales";

interface TaskNotificationTitleCreatorSeriesUpdateProps extends ComponentNotificationTitleSeriesUpdate {
  read: boolean;
}

const TaskNotificationTitleCreatorSeriesUpdate = ({
  props: { updatedBy },
  read,
}: TaskNotificationTitleCreatorSeriesUpdateProps) => {
  const { t } = useTranslation();
  const updatedByString = getTitleAssignerString(updatedBy);
  return (
    <div className={styles["task-notification-item-title"] ?? ""}>
      {!read && <FixaSSRIcon paths={CircleFilledIconPath} />}
      {t("taskSeriesUpdatedByString", { updatedBy: updatedByString })}
    </div>
  );
};

export default TaskNotificationTitleCreatorSeriesUpdate;
